
export const FacebookOAuth = () => {
    return <></>
}